module.exports = __webpack_public_path__ + "ea11af5b5dccf9662a20f7b640a5e2d8.svg";